import { render, staticRenderFns } from "./xuanzeLd.vue?vue&type=template&id=479679f8&scoped=true&"
import script from "./xuanzeLd.vue?vue&type=script&lang=js&"
export * from "./xuanzeLd.vue?vue&type=script&lang=js&"
import style0 from "./xuanzeLd.vue?vue&type=style&index=0&id=479679f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479679f8",
  null
  
)

export default component.exports